import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';


/**
 * Modèle pour une modalité
 */
export class Modalite {
  constructor(
    public code: string = null,
    public libelle: string = null
  ) { }
}

/**
 * Service permettant de charger les modalités des différentes variables de
 * l'application, et d'y accéder par la suite dans les composants qui en
 * ont besoin.
 */
@Injectable({
  providedIn: 'root'
})
export class ModalitesService {
  private mapVariablesModalites: Map<string, BehaviorSubject<Modalite[]>> = new Map<string, BehaviorSubject<Modalite[]>>();
  private url: string;
  private chargementOk: boolean = false;
  constructor(
    private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
  ) {
    // this.init();
  }
  public getModalites(nomVariable: string): BehaviorSubject<Modalite[]> {
    if (!this.mapVariablesModalites.get(nomVariable)) {
      // Les modalités relatives à cette variable ne sont pas disponibles. On initialise un tableau vide
      this.mapVariablesModalites.set(nomVariable, new BehaviorSubject([]));
    }
    return this.mapVariablesModalites.get(nomVariable);

  }
  /**
   * fonction d’initialisation des données métiers du service
   */
  public init(): void {
    this.url = this.apiUrl + '/nomenclatures';
    /* mapModalites.forEach((modalites, nomVariable) => {
      this.getModalites(nomVariable).next(modalites);
    });*/
    this.http.get<{ [nomVariable: string]: Modalite[] }>(this.url)
      .subscribe(
        nomenclatures => {
          Object.keys(nomenclatures).forEach(nomenclatureNom => {
            this.getModalites(nomenclatureNom).next(nomenclatures[nomenclatureNom]);
          });
          this.chargementOk = true;
        }
      );
  }
  /**
* Retourne si le chargement des nomenclatures s’est bien passé
*/
  public nomenclaturesChargees(): boolean {
    return this.chargementOk;
  }

  /**
   * Fonction permettant de rechercher une commune depuis un libellé ou un code
   * @param libelle libelle d’une commune
   */
  public getCommune(filtre: string, code: string): Observable<Modalite[]> {
    const url = this.apiUrl + '/nomenclature/commune';
    let params = new HttpParams();
    params = params.set('ajoutCodeDepartement', 'true');
    params = params.set('utiliseDateFermetureCommune', 'true');
    if (filtre && filtre !== '') {
      params = params.set('libelle', filtre);
    }
    if (code) {
      params = params.set('code', code);
    }
    return this.http.get<Modalite[]>(url, { params: params }).pipe(debounceTime(500), distinctUntilChanged());
  }

}
